import React, { useState, useEffect } from "react";
import { Edit3 } from "lucide-react";
import { toast } from "react-toastify";
import { getPricingPlansOverview } from "../../../../services/apiAndBillingService";

const PricingPlansOverview = () => {
  const [pricingPlans, setPricingPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPricingPlans = async () => {
      try {
        setLoading(true);
        const data = await getPricingPlansOverview();
        setPricingPlans(data.pricingPlans || []);
      } catch (err) {
        toast.error(`Failed to load pricing plans: ${err.message}`);
        console.error('Error fetching pricing plans:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPricingPlans();
  }, []);

  const formatPrice = (price) => {
    if (price === 0) return "$0";
    return `$${price}`;
  };

  const formatNumber = (number) => {
    return number.toLocaleString();
  };

  const formatCurrency = (amount) => {
    return `$${amount.toLocaleString()}`;
  };

  const getRevenueColor = (revenue) => {
    return revenue > 0 ? "text-green-600" : "text-gray-600";
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded mb-6 w-48"></div>
          <div className="space-y-4">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <div className="h-5 bg-gray-200 rounded w-32"></div>
                  <div className="h-6 bg-gray-200 rounded w-16"></div>
                </div>
                <div className="h-4 bg-gray-200 rounded w-48 mb-3"></div>
                <div className="flex items-center justify-between">
                  <div className="flex space-x-4">
                    <div className="h-4 bg-gray-200 rounded w-20"></div>
                    <div className="h-4 bg-gray-200 rounded w-24"></div>
                  </div>
                  <div className="h-8 bg-gray-200 rounded w-16"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-600 text-sm">Error loading pricing plans: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Pricing Plan Overview</h3>
      </div>
      
      <div className="space-y-4">
        {pricingPlans.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            No pricing plans available
          </div>
        ) : (
          pricingPlans.map((plan, index) => (
            <div key={index} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-medium text-gray-900">{plan.planName}</h4>
                  <span className="text-lg font-bold text-gray-900">{formatPrice(plan.price)}</span>
                </div>
                <p className="text-sm text-gray-600 mb-3">{plan.details}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-600">
                      <span className="font-medium">{formatNumber(plan.users)}</span> users
                    </span>
                    <span className={`text-sm font-medium ${getRevenueColor(plan.revenue)}`}>
                      <span className="font-bold">{formatCurrency(plan.revenue)}</span> revenue
                    </span>
                  </div>
                  {/* <button className="flex items-center space-x-1 px-3 py-1.5 text-sm text-white  bg-secondary rounded-md transition-colors">
                    <Edit3 className="w-4 h-4" />
                    <span>Edit</span>
                  </button> */}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PricingPlansOverview;
